/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { Icon as Icon$1 } from 'tdesign-icons-vue-next';
import withInstall from '../utils/withInstall.mjs';

var Icon = withInstall(Icon$1, "TIcon");

export { Icon, Icon as default };
//# sourceMappingURL=index.mjs.map
